/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Step2_TitleInputs */

const en_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI tailors to the job`)
};

const de_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI passt an die Stelle an`)
};

const fr_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA s'adapte au poste`)
};

const es_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA lo adapta al puesto`)
};

const it_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'AI lo adatta al lavoro`)
};

const nl_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI stemt af op de baan`)
};

const pl_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI dopasowuje do oferty`)
};

const fi_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoäly räätälöi työpaikkaan`)
};

const da_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI tilpasser til jobbet`)
};

const sv_landing_how_step2_title = /** @type {(inputs: Landing_How_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI anpassar till jobbet`)
};

/**
* | output |
* | --- |
* | "AI tailors to the job" |
*
* @param {Landing_How_Step2_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_step2_title = /** @type {((inputs?: Landing_How_Step2_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Step2_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_step2_title(inputs)
	if (locale === "fr") return fr_landing_how_step2_title(inputs)
	if (locale === "es") return es_landing_how_step2_title(inputs)
	if (locale === "it") return it_landing_how_step2_title(inputs)
	if (locale === "nl") return nl_landing_how_step2_title(inputs)
	if (locale === "pl") return pl_landing_how_step2_title(inputs)
	if (locale === "fi") return fi_landing_how_step2_title(inputs)
	if (locale === "da") return da_landing_how_step2_title(inputs)
	if (locale === "sv") return sv_landing_how_step2_title(inputs)
	return en_landing_how_step2_title(inputs)
});